import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import RepresentativeCard, {
  Representative,
} from '../RepresentativeCard/RepresentativeCard';
import { SPACING, RADIUS } from '../../../theme/theme';

interface BoxProps {
  content_status: string;
  statusColor: string;
  statusBgColor: string;
  name: string;
  display_name: string;
  wallets_count: number;
  publish_status: string;
  sibche_address: string;
  identityStatus: string;
  actionButton: React.ReactNode;
  identityButton: React.ReactNode;
  published_applications_count: number;
  applications_count: number;
  identity_type: string;
  identity_id: number;
  representatives?: Representative[]; // آرایه نماینده‌ها (اختیاری)
  onRevokeAccess?: (rep: Representative) => void;
  onRemoveRepresentative?: (rep: Representative) => void;
}

const CustomBox: React.FC<BoxProps> = ({
  name,
  display_name,
  wallets_count,
  sibche_address,
  published_applications_count,
  applications_count,
  actionButton,
  identityButton,
  identity_type,
  identity_id,
  representatives = [], // پیش‌فرض آرایه خالی
  onRevokeAccess,
  onRemoveRepresentative,
}) => {
  const commonTypographyStyles = {
    fontFamily: 'IRANYekanXFaNum',
    lineHeight: '20px',
    textAlign: 'right' as const,
  };

  // Convert identity_type to Persian and get color
  const getIdentityTypeDisplay = (type: string) => {
    switch (type) {
      case 'PERSONAL':
        return { text: 'هویت شخصی', color: '#60646E' };
      case 'LEGAL':
        return { text: 'هویت حقوقی', color: '#60646E' };
      default:
        return { text: type, color: '#60646E' };
    }
  };

  const identityDisplay = getIdentityTypeDisplay(identity_type);

  // Truncate name to 15 characters with ellipsis
  const truncateText = (text: string, maxLength: number) =>
    text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

  return (
    <Box sx={{ width: '100%' }}>
      <RepresentativeCard
        key={`${identity_id}-${representatives.length}`}
        representatives={representatives}
        cardWidth="100%"
        cardHeight={150}
        onRevokeAccess={onRevokeAccess}
        onRemoveRepresentative={onRemoveRepresentative}
      >
        {/* Same surface treatment as the application cards: white panel,
            rounded corners and a soft shadow instead of the cyan gradient. */}
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            minHeight: 150,
            display: 'flex',
            flexDirection: 'column' as const,
            direction: 'rtl' as const,
            p: `${SPACING.lg}px`,
            gap: `${SPACING.md}px`,
            boxSizing: 'border-box',
            backgroundColor: 'white',
            border: 'none',
            borderRadius: `${RADIUS.lg}px`,
            boxShadow: '0 2px 10px rgba(16, 24, 40, 0.06)',
            transition: 'box-shadow .2s ease, transform .2s ease',
            cursor: 'pointer',
            '&:hover': {
              boxShadow: '0 6px 18px rgba(16, 24, 40, 0.10)',
              transform: 'translateY(-2px)',
            },
          }}
        >
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="h6"
            sx={{
              ...commonTypographyStyles,
              fontWeight: 700,
              fontSize: '13px',
              lineHeight: '18px',
              color: '#25282E',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis', // Truncate long text with ellipsis
            }}
            title={name} // Show full text on hover
          >
            {truncateText(name, 15)}
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              ...commonTypographyStyles,
              fontWeight: 500,
              fontSize: '11px',
              color: '#A6AAB5',
              mt: `${SPACING.sm}px`,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis', // Truncate long text with ellipsis
            }}
            title={display_name} // Show full text on hover
          >
            {display_name}
          </Typography>
        </Box>
        <Box sx={{ flexShrink: 0 }}>{actionButton}</Box>
      </Box>

      <Divider sx={{ borderColor: '#EDEDF0' }} />

      <Box display="flex" justifyContent="space-between" sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column' as const,
            gap: '8px',
          }}
        >
          {/* <Typography
            variant="caption"
            sx={{
              ...commonTypographyStyles,
              fontWeight: 400,
              fontSize: '12px',
              color: '#5C5C5C',
            }}
          >
            موجودی کیف پول
          </Typography> */}
          <Typography
            variant="h6"
            sx={{
              ...commonTypographyStyles,
              fontWeight: 400,
              fontSize: '11px',
              color: '#60646E',
            }}
          >
            اپلیکیشن (کل/فعال)
          </Typography>
          {/* <Typography
            variant="caption"
            sx={{
              ...commonTypographyStyles,
              fontWeight: 400,
              fontSize: '12px',
              color: '#5C5C5C',
            }}
          >
            آدرس در سیبچه
          </Typography> */}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column' as const,
            gap: '8px',
            maxWidth: '50%',
          }}
        >
          {/* <Typography
            variant="h6"
            sx={{
              ...commonTypographyStyles,
              fontWeight: 400,
              fontSize: '12px',
              color: '#5C5C5C',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis', // Truncate long text with ellipsis
            }}
          >
            {wallets_count + '  ریال'}
          </Typography> */}
          {/* <Typography
            variant="h6"
            sx={{
              ...commonTypographyStyles,
              fontWeight: 400,
              fontSize: '12px',
              color: '#5C5C5C',
            }}
          >
            {published_applications_count}/{applications_count}
          </Typography> */}
          {/* <Typography
            variant="h6"
            sx={{
              ...commonTypographyStyles,
              fontWeight: 400,
              fontSize: '12px',
              color: '#5C5C5C',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis', // Truncate long text with ellipsis
            }}
            title={sibche_address} // Show full text on hover
          >
            {sibche_address}
          </Typography> */}
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ flexShrink: 0 }}
      >
        <Typography
          variant="h6"
          sx={{
            ...commonTypographyStyles,
            fontWeight: 600,
            fontSize: '12px',
            color: identityDisplay.color,
          }}
        >
          {identityDisplay.text}
        </Typography>
        <Box>{identityButton}</Box>
      </Box>
        </Paper>
      </RepresentativeCard>
    </Box>
  );
};

export default CustomBox;
